<span
  class="ui-button__tooltip"
  [matTooltip]="displayableTooltip | translate"
  [matTooltipPosition]="tooltipPosition"
  [matTooltipClass]="tooltipClass"
  (click)="onClick($event)"
>
  <ng-template #buttonIcon>
    @if (loading) {
      <mat-spinner
        diameter="16"
        class="button-spinner ui-button__spinner"
        aria-hidden="true"
      ></mat-spinner>
    } @else if (displayedIcon) {
      <mat-icon class="ui-button__icon" [color]="iconColor">{{ displayedIcon }}</mat-icon>
    }
  </ng-template>
  <ng-template #buttonContent>
    <span
      class="icon-text-container ui-button__content"
      [class.ui-button__content--right]="iconPosition === 'right'"
      [class.ui-button__content--loading]="loading && !displayedIcon"
    >
      @if (displayedIcon || loading) {
        <ng-container *ngTemplateOutlet="buttonIcon"></ng-container>
      }
      <span class="ui-button__label">{{ text }}</span>
    </span>
  </ng-template>
  @switch (buttonType) {
    @case ('raised') {
      <button
        mat-raised-button
        [class]="buttonClasses"
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="ariaLabel || (loading ? text : null)"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case ('stroked') {
      <button
        mat-stroked-button
        [class]="buttonClasses"
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="ariaLabel || (loading ? text : null)"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case ('secondary') {
      <button
        mat-stroked-button
        [class]="buttonClasses"
        class="mat-secondary"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="ariaLabel || (loading ? text : null)"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case ('mat') {
      <button
        mat-button
        [class]="buttonClasses"
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="ariaLabel || (loading ? text : null)"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case ('link') {
      <button
        mat-button
        [class]="buttonClasses"
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="ariaLabel || (loading ? text : null)"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case ('fab') {
      <button
        mat-fab
        [class]="buttonClasses"
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="ariaLabel || (loading ? text : null)"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
      </button>
    }
    @case ('icon-button') {
      <button
        mat-icon-button
        [class]="buttonClasses"
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        [attr.aria-busy]="loading || null"
        [attr.aria-label]="
          ariaLabel || (tooltip | translate) || (text !== 'button' ? text : displayedIcon)
        "
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonIcon"></ng-container>
      </button>
    }
  }
</span>
